"use strict";

exports.__esModule = true;
exports.default = void 0;

var _formTextarea = require("./form-textarea");

var _plugins = require("../../utils/plugins");

var components = {
  BFormTextarea: _formTextarea.default,
  BTextarea: _formTextarea.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/form-textarea/index.js
// module id = xUiR
// module chunks = 14